import { HistoryTimeline } from "../../components";
import { useGetLeadHistory } from "../../hooks/react-query/useSalesData";
import { LEAD_STAGE_LABELS } from "../../constants/salesStages";

const getStageLabel = (stage) =>
  LEAD_STAGE_LABELS.find((s) => s.id === stage)?.label || `Stage ${stage}`;

const getStageFlow = (stage) =>
  LEAD_STAGE_LABELS.find((s) => s.id === stage)?.flow || "grey";

const LeadTimeline = ({ leadId }) => {
  const { data: history } = useGetLeadHistory(leadId);

  return (
    <HistoryTimeline
      history={history || []}
      getStageLabel={getStageLabel}
      getStageFlow={getStageFlow}
    />
  );
};

export default LeadTimeline;
